var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo",attrs:{"to":"/"}},[_c('img',{staticClass:"logo__image",attrs:{"src":require("@/assets/logo.png")}}),_c('div',{staticClass:"logo__slogan"},[_vm._v("Будь в курсі!")])])}
var staticRenderFns = []

export { render, staticRenderFns }